import React from 'react';
import { observer } from 'mobx-react';
import { CorporateListTemplate } from 'themes/application/corporate/pages';
import { setCurrentView } from 'core/utils';
import { CorporateViewStore } from 'application/corporate/stores';

@setCurrentView((rootStore) => new CorporateViewStore(rootStore), 'listViewStore')
@observer
class CorporateList extends React.Component {
    render() {
        return <CorporateListTemplate {...this.props} />
    }
}

export default CorporateList;